import DateRangeMenu from 'src/components/Overlays/DateRangeMenu'
import { VoEType } from 'src/graphql/types/verificationOfEmployments'

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface VoEAnalyticsFilters {
  dateRange?: { gte?: string; lte?: string }
  voeTypes?: string[]
  applicantStages?: string[]
}

export interface VoEFiltersBarProps {
  startDate: Date | null
  endDate: Date | null
  onFiltersChange: (filters: VoEAnalyticsFilters) => void
  onStartDateChange: (date: Date | null) => void
  onEndDateChange: (date: Date | null) => void
}

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

function buildFilters(startDate: Date | null, endDate: Date | null): VoEAnalyticsFilters {
  const filters: VoEAnalyticsFilters = {
    voeTypes: [VoEType.OUTBOUND],
  }

  if (startDate || endDate) {
    filters.dateRange = {}
    if (startDate) filters.dateRange.gte = startDate.toISOString()
    if (endDate) filters.dateRange.lte = endDate.toISOString()
  }

  return filters
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export const VoEFiltersBar = ({
  startDate,
  endDate,
  onFiltersChange,
  onStartDateChange,
  onEndDateChange,
}: VoEFiltersBarProps) => {
  return (
    <div className="flex flex-row items-center">
      <div className="ml-auto">
        <DateRangeMenu
          startDate={startDate}
          endDate={endDate}
          handleChange={(value: [Date | null, Date | null]) => {
            const [s, e] = value
            onStartDateChange(s)
            onEndDateChange(e)
            onFiltersChange(buildFilters(s, e))
          }}
          clearable={true}
        />
      </div>
    </div>
  )
}
